import React, { useState } from "react";
import { Container, Box, Input, Send, Button } from "./styles";
import { MdAlternateEmail } from "react-icons/md";
import { IoLockClosedSharp } from "react-icons/io5";
import { useAuth } from "@hooks/auth";
import axios from "axios";
import { toast } from "react-toastify";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { setStatus, setToken, setUser, getProjeto } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  function handleSubmit() {
    if (!email || !password) {
      toast.error("Por favor, preencha todos os campos.");
      return;
    }

    setIsLoading(true);

    const payload = {
      email: email,
      password: password,
    };

    axios
      .post(`https://dev.vidal-app.com/auth`, payload)
      .then((response) => {
        if (response.status === 200) {
          setToken(response.data.token);
          setUser(response.data.user);

          // Configurar o token nos cabeçalhos padrão do Axios
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${response.data.token}`;

          // Buscar projetos do usuário
          getProjeto()
            .then(() => {
              // Após buscar projetos com sucesso, mudar para a tela de projetos
              setStatus("projetos");
              toast.success("Login realizado com sucesso!");
            })
            .catch((error) => {
              console.error("Erro ao buscar projetos:", error);
              toast.error("Erro ao carregar seus projetos. Tente novamente.");
            });
        } else {
          toast.error("Falha: Não foi possível autenticar o usuário.");
        }
      })
      .catch((error) => {
        if (error.response) {
          // O servidor retornou uma resposta
          toast.error(
            `Erro: ${
              error.response.data.message ||
              error.response.data.error ||
              "Algo deu errado. Tente novamente mais tarde."
            }`
          );
        } else {
          // Ocorreu um erro durante a solicitação
          toast.error("Erro: Algo deu errado. Tente novamente mais tarde.");
        }
        console.error("Erro ao autenticar:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  // Handler para submissão do formulário ao pressionar Enter
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <Container id="login-container">
      <Box>
        <Input>
          <MdAlternateEmail />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={handleKeyDown}
            required
            placeholder="E-mail"
            autoComplete="email"
          />
        </Input>
        <Input>
          <IoLockClosedSharp />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyDown}
            required
            placeholder="Senha"
            autoComplete="current-password"
          />
        </Input>
        <Send>
          <Button
            onClick={handleSubmit}
            disabled={isLoading}
            style={{ opacity: isLoading ? 0.7 : 1 }}
          >
            <p>{isLoading ? "Entrando..." : "Entrar"}</p>
          </Button>
        </Send>
      </Box>
    </Container>
  );
}
